import { jsx as a } from "react/jsx-runtime";
const d = ({ ariaDescribedby: e, ariaLabel: r, children: i, className: l }) => /* @__PURE__ */ a(
  "nav",
  {
    "aria-describedby": e,
    "aria-label": r,
    className: l,
    children: /* @__PURE__ */ a("ul", { children: i })
  }
);
d.displayName = "Menu.Nav";
export {
  d as default
};
